/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".m-r8[_ngcontent-%COMP%]{margin-right:6px;line-height:12px;vertical-align:top}"];
export { styles as styles };
